import React, { Component } from 'react';
import {
  Row,
  Col,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardGroup, Table,
  Progress,
  Collapse, Button, Fade,
  ListGroup, ListGroupItem, ListGroupItemHeading, ListGroupItemText,
  Input,
  InputGroup,
  FormGroup,
  InputGroupAddon,
  InputGroupText
} from 'reactstrap';
import moment from 'moment';

class Documentation extends Component {

  constructor(props) {
    super(props);
  }

  async componentDidMount() {
  }

  render() {

    return (
      <div className="animated fadeIn" style={{display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column"}}>
        <h4><a href="https://drive.google.com/drive/u/0/folders/1dL8FwFZHedOnn1YPY-L-rlzvNhlhixSw" target="_blank">Design Mobile</a></h4>
        <h4><a href="https://drive.google.com/drive/u/0/folders/1fmZpz1VofgZ-76n8q7Ff1CS2QGCEkf-g" target="_blank">Design Web</a></h4>
        <h4><a href="https://docs.google.com/spreadsheets/d/10U6jyjuvLZUTlVlaR3BlsmU6ik3ioICTM2RwsU4K0zQ/edit#gid=1379304495" target="_blank">Tiến độ Mobile</a></h4>
        <h4><a href="https://docs.google.com/spreadsheets/d/1SFmOxx1keRiheDWnXKx_lORHkn-7iX9pvc3rMPsxixE/edit#gid=1091745004" target="_blank">Tiến độ Web</a></h4>
      </div>
    );
  }
}

export default Documentation;


// WEBPACK FOOTER //
// ./src/views/Dashboard/Documentation.js